<dl class="mt-n3 py-2 sb-metric-grid" [class.sb-metric-grid-horizontal]="forceHorizontal">
    <div
        *ngFor="let metric of metrics$ | async; trackBy: trackByIndexFn"
        class="sb-metric-item"
        [style.--divider-color]="
            metric.addColor && metric.value > 0
                ? 'var(--text-positive-color)'
                : metric.addColor && metric.value < 0
                ? 'var(--text-negative-color)'
                : null
        "
    >
        <dt class="d-flex align-items-center align-self-start">
            {{ metric.title }}
            <sb-tooltip-info
                *ngIf="metric.description"
                [tooltipText]="metric.description"
                size="sm"
            ></sb-tooltip-info>
        </dt>
        <dd
            @fadeInOut
            *ngIf="metric?.loading !== true && metric.value !== null; else loading"
        >
            <ng-container *ngIf="metric.type !== 'text'; else textValue">
                <sb-animated-number
                    [useMonotypeFont]="false"
                    [prefix]="
                        (metric.prefixPositiveValue && metric.value > 0
                            ? '+&nbsp;'
                            : null) ||
                        metric.prefix ||
                        null
                    "
                    [suffix]="metric.suffix || null"
                    [ccy]="metric.ccy"
                    [value]="metric.value"
                    [class.text-positive]="metric.addColor && metric.value > 0"
                    [class.text-negative]="metric.addColor && metric.value < 0"
                    [formatStyle]="metric.formatStyle || null"
                    [minimumFractionDigits]="metric.minimumFractionDigits"
                    [maximumFractionDigits]="metric.maximumFractionDigits"
                ></sb-animated-number>
            </ng-container>
            <ng-template #textValue>
                <span class="font-weight-bold">{{ metric.value }}</span>
            </ng-template>
        </dd>
        <dd
            @fadeInOut
            *ngIf="
                !metric.loading && metric.change !== null && metric.change !== undefined
            "
            [class.text-positive]="
                metric.addColor && (metric?.change > 0 || metric?.change[0] > 0)
            "
            [class.text-negative]="
                metric.addColor && (metric.change < 0 || metric.change[0] < 0)
            "
        >
            <tabler-icon
                style="height: 18px; width: 18px"
                name="circle-arrow-up"
                [class.sb-transform-r90]="metric.change === 0"
                [class.sb-transform-r45]="metric.change > 0 || metric.change[0] > 0"
                [class.sb-transform-r135]="metric.change < 0 || metric.change[0] < 0"
                class="me-1 tabler-fill-circle sb-transform-animate"
            ></tabler-icon>
            <ng-container *ngIf="!isNaN(metric.change)">
                (
                <sb-animated-number
                    [useMonotypeFont]="false"
                    formatStyle="percent"
                    [value]="metric.change"
                ></sb-animated-number>
                )
            </ng-container>

            <ng-container *ngIf="isNaN(metric.change)">
                <sb-animated-number
                    formatStyle="decimal"
                    [useMonotypeFont]="false"
                    [value]="metric.change[0]"
                ></sb-animated-number>
                &nbsp; (
                <sb-animated-number
                    [useMonotypeFont]="false"
                    formatStyle="percent"
                    [value]="metric.change[1]"
                ></sb-animated-number>
                )
            </ng-container>
        </dd>
    </div>
</dl>
<ng-template #loading>
    <dd>
        <span class="text-nowrap text-muted" aria-busy="true">Loading...</span>
    </dd>
</ng-template>
